<template>
	<div data-v-steps="2">
		<div v-show="smScrennFull" class="small-screenfull">
			<el-drawer style="z-index: 20000;" title="我是标题" :visible.sync="openDrawer" :with-header="false"
				:direction='openDirection' size='240px' :modal-append-to-body="modal">
				<div class="nav">
					<div class="page_navtitle">
						<img :src="logoimg" v-if="logoimg" alt="" class="logo-img">
						<span class="logoimg" v-if="!logoimg"></span>
						<div class="fl">
							<span class="navtitle_city fwb">{{leftNavTitle}}</span><span class="navtitle_web fwb"
								:style="curWebsite.shortname.length>8?'font-size:18px':''">{{curWebsite.shortname}}</span>
						</div>
					</div>
					<div class="oh flexcss left-nav-version-title" v-show="curWebsite.type == 1 || curWebsite.type == 7 || curWebsite.type == 8">
						<span :class="['title',zsdn_version == 1 ?'current':'', ]" @click="zsdnVersionToggle(1)">易用版<i class="el-icon el-icon-check" v-show="zsdn_version == 1"></i></span>
						<span :class="['title',zsdn_version == 2 ?'current':'', ]" @click="zsdnVersionToggle(2)">专业版<i class="el-icon el-icon-check" v-show="zsdn_version == 2"></i></span>
					</div>
					<dl :class="['menu_block',{'current':mkcode==list.code},{'dn':editionBlock.indexOf(list.code)>0&&edition<1}]"
						:key="index" v-for="(list,index) in localRouter" v-show="list.switch">
						<dt class="dt_nav">
							<span @click="navClickLink(list)"><i :class="list.icontype"></i>{{list.oldtext}}</span>
							<span :title="list.open?'展开':'收起'" v-if="list.openicon" @click="list.open=!list.open"><i
									:class="list.open?'el-icon-arrow-up':'el-icon-arrow-down'"
									style="margin-left: 20px"></i></span>
						</dt>
						<dd v-show="list.open"> 
							<span
								:class="['nav_li',{'li-current':itemcode==item.code},{'db':item.oldtext.length>6},{'red-icon':item.newType}]"
								:key="eq" :data="item.newType" v-for="(item,eq) in list.children"
								@click="navClickLink(item)" v-show="item.switch">{{item.oldtext}}</span>
							<span v-show="list.morebtn" @click="showMoreNav(list)">更多功能<i class="el-icon-arrow-down"
									style="margin-left:3px"></i></span>
						</dd>
					</dl>
				</div>
			</el-drawer>
			<span class="screen" @click="openDrawer = true" style="z-index: 1999;"><i
					class="el-icon-s-unfold"></i>菜单栏</span>
		</div>
		<div v-show="!smScrennFull" class="common-screenfull" id="testbox">
			<div class="nav" :style="isCollapse?'width: 0px;':''">
				<span class="meunm-close-btn"  title="关闭菜单" @click="onClickfoldBtn"><i class="el-icon-close"></i></span>
				<div class="page_navtitle">
						<img :src="logoimg" v-if="logoimg" alt="" class="logo-img">
						<span class="logoimg" v-if="!logoimg"></span>
					<div class="fl">
						<span class="navtitle_city fwb"
							:style="getTitleFontSize(leftNavTitle)">{{leftNavTitle}}</span><span
							class="navtitle_web fwb"
							:style="curWebsite.shortname.length>8?'font-size:16px':''">{{curWebsite.shortname}}</span>
					</div>
				</div> 
				<div class="oh flexcss left-nav-version-title" v-show="curWebsite.type == 1 || curWebsite.type == 7 || curWebsite.type == 8">
					<span :class="['title',zsdn_version == 1 ?'current':'', ]" @click="zsdnVersionToggle(1)">易用版<i class="el-icon el-icon-check" v-show="zsdn_version == 1"></i></span>
					<span :class="['title',zsdn_version == 2 ?'current':'', ]" @click="zsdnVersionToggle(2)">专业版<i class="el-icon el-icon-check" v-show="zsdn_version == 2"></i></span>
				</div>
				<dl :class="['menu_block',{'current':mkcode==list.code},{'dn':editionBlock.indexOf(list.code)>0&&edition<1}]"
					:key="index" v-for="(list,index) in localRouter" v-show="list.switch">
					<dt class="dt_nav">
						<span @click="navClickLink(list)" :class="mktype == list.type? 'darkred': ''"><i :class="list.icontype"></i>{{list.oldtext}}</span>
						<span :title="list.open?'展开':'收起'" v-if="list.openicon" @click="list.open=!list.open"><i
								:class="list.open?'el-icon-arrow-up':'el-icon-arrow-down'"
								style="margin-left: 20px"></i></span>
					</dt>
					<dd v-show="list.open">
						<!--  -->
						<span
							:class="['nav_li',{'li-current':itemcode==item.code},{'db':item.oldtext.length>6 }, {'red-icon':item.newType} ]"
							:data="item.newType" :key="eq" v-for="(item,eq) in list.children"
							@click="navClickLink(item)" v-show="item.switch">{{item.oldtext}}</span>
						<span v-show="list.morebtn" @click="showMoreNav(list)">更多功能<i class="el-icon-arrow-down"
								style="margin-left:3px"></i></span>
					</dd>
				</dl>
			</div>
		</div>
		<operatDemo :userdata="userdata" v-if="curWebsite.type == 8 || curWebsite.type == 1 || curWebsite.type == 6 || curWebsite.type == 4"></operatDemo>
		<messgeAlertPop :userdata="userdata" v-if="isMsgAlert"></messgeAlertPop>
	</div>
</template>
<script>
	import screenfull from 'screenfull'
	// import $ from "jquery" 
	import ajaxapi from "@/utils/api.js"
	import messgeAlertPop from "@/components/inc/messge-alert-pop"
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'leftNav', 
		computed: {
		...mapState({
		isMsgAlert: (state) => state.isMsgAlert,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse','isMsgAlert'])
		},
		data() {
			return {
				logoimg:'',
				zsdn_version: 1, //产业招商大脑type=1 || type=7时使用 1为简易版 2为专业版
				enabled: false,
				steps: [{
						target: '#testbox', // 需要引导的目标元素的 CSS 选择器
						content: '这是第一步引导', // 引导内容
						placement: 'top' // 引导页对齐方式 
					},
					{
						target: '.search-box',
						content: '这是第二步引导'
					}
				],
				leftNavTitle: "", //
				mkcode: "",
				curWebsite: this.$api.getWebsiteType(),
				autoOperate: true,
				isFullscreen: false,
				openDrawer: false,
				modal: false,
				openDirection: "ltr", //btt
				openDirection2: "btt", //btt
				edition: 0, //0为普通版 1为专业版 &cyyj&datu
				groupType: 0, //0为试用账户 1为正式账户 &cyyj&datu
				editionBlock: "&B&C", //普通版就会被隐藏的板块
				islogin: false,
				userdata: {},
				menucurType: 0,
				menucurLi: 0,
				zhengshipage: "全国图谱-产业链详情页，当地图谱-目标企业-概念下当地企业详情，产业园区库-园区详情页 招商情报- 招商情报详情页 产业政策-政策详情页 城市监测里的图",
				nums: 1,
				localRouter: [],
				cyzsMoreshow: "&科研机构&招商地图&研发机构&协会商会&专业镇", //工作台里的&统计分析&项目管理&跟进记录&待办记录 已经加上大板块的收缩隐藏了
				localRouter_zs_simple: [ //招商大脑 上海数据平台使用的简易版
					//看项目投资趋势
					{
						code: "P",
						switch: true,
						name: "",
						type: "tzqs",
						oldtext: "看项目投资趋势",
						url: "/invest-project-trend?type=3",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-opportunity",
						children: [{	
							code: "P-QYZBCNDTZ",
							switch: true,
							name: "",
							oldtext: "企业在本市拿地投资项目",
							url: "/invest-project-trend?type=3"
						},
						{
							code: "P-SSGSZBCTZ",
							switch: true,
							name: "",
							oldtext: "上市公司在本市投资项目",
							// url: "/city-invest-project"
							url: "/invest-project-trend?type=1"
						}, {
							code: "P-QYZBSNDTZ",
							switch: true,
							name: "",
							oldtext: "企业在本省拿地投资项目",
							url: "/invest-project-trend?type=4"
						},{
							code: "P-SSGSZBSTZ",
							switch: true,
							name: "",
							oldtext: "上市公司在本省投资项目",
							// url: "/province-invest-project"
							url: "/invest-project-trend?type=2"
						}, 
						{
							code: "P-BSQYZWDTZ",
							switch: true,
							name: "",
							oldtext: "本市企业在外地投资项目",
							// url: "/province-invest-project"
							url: "/invest-project-trend?type=5"
						}, 
						]
					},
					{
						code: "A",
						switch: true,
						name: "",
						type: "tzqs",
						oldtext: "找招商目标企业",
						url: "/allchain",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-opportunity",
						children: [ {
							code: "A-CYTP",
							switch: true,
							name: "",
							oldtext: "从产业图谱找企业",
							url: "/allchain"
						}, {
							code: "A-ZDCYZQY",
							switch: true,
							name: "",
							oldtext: "按重点产业找企业",
							url: "/simple-enterprise-list?type=notion"
						}, {
							code: "A-ZDCSZQY",
							switch: true,
							name: "",
							oldtext: "按重点城市找企业",
							url: "/simple-enterprise-list?type=city"
						},{
							code: "A-CXQY",
							switch: true,
							name: "",
							oldtext: "按融资阶段找企业",
							url: "/enterpriseList?type=2"
						},{
							code: "A-QYLXZQY",
							switch: true,
							name: "",
							oldtext: "按企业类型找企业",
							url: "/simple-enterprise-list?type=strength"
						}, {
							code: "C-QYTZCK",
							switch: true,
							name: "",
							oldtext: "从投资窗口期找企业",
							url: "/enterpriseInvestmentWindow"
						},
						]
					},
					{
						code: "PDQY",
						switch: true,
						name: "",
						type: "PDQY",
						oldtext: "判断企业投资意向",
						url: "/tenEnterprisesComparison",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-opportunity",
						children: [{
							code: "PD-ZHSL",
							switch: true,
							name: "",
							oldtext: "判断企业综合实力",
							url: "/tenEnterprisesComparison?type=1"
						},  
						{
							code: "PD-CWSL",
							switch: true,
							name: "",
							oldtext: "判断企业财务实力",
							url: "/tenEnterprisesComparison?type=2"
						}, 
						{
							code: "PD-TZDT",
							switch: true,
							name: "",
							oldtext: "了解企业投资动态",
							url: "/tenEnterprisesComparison?type=3"
						}, 
						{
							code: "PD-TZBJ",
							switch: true,
							name: "",
							oldtext: "了解企业投资布局",
							url: "/tenEnterprisesComparison?type=4"
						}, 
						{
							code: "PD-TZYX",
							switch: true,
							name: "",
							oldtext: "判断企业投资意向",
							url: "/tenEnterprisesComparison?type=5"
						}, 
						]
					},
					{
						code: "J",
						switch: true,
						name: "",
						type: "jllx",
						oldtext: "与企业建立联系",
						url: "/enterprisesCityRelation-province",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-opportunity",
						children: [{
							code: "J-GD",
							switch: true,
							name: "",
							oldtext: "本地企业外地股东",
							url: "/enterprisesCityRelation-province?type=1"
						},  
						{
							code: "J-DWTZ",
							switch: true,
							name: "",
							oldtext: "本地企业对外投资",
							url: "/enterprisesCityRelation-province?type=2"
						}, 
						{
							code: "J-GYS",
							switch: true,
							name: "",
							oldtext: "本地企业的外地供应商",
							url: "/enterprisesCityRelation-province?type=3"
						}, 
						{
							code: "J-KH",
							switch: true,
							name: "",
							oldtext: "本地企业的外地客户",
							url: "/enterprisesCityRelation-province?type=4"
						}, 
						{
							code: "J-TZJG",
							switch: true,
							name: "",
							oldtext: "相同投资机构下的外地企业",
							url: "/enterprisesCityRelation-province?type=6"
						}, 
						]
					},
					{
						code: "R",
						switch: true,
						name: "学习行业提升专业",
						oldtext: "学习行业提升专业",
						type: "yjbg",
						url: "report",
						open: true,
						icontype: "el-icon-s-management",
						children: [{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "数字经济研究报告",
								url: "reportList",
								reportId: 10005,
							},
							{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "高端制造研究报告",
								url: "reportList",
								reportId: 10014,
							},
							{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "能源环保材料研究报告",
								url: "reportList",
								reportId: 10024,
							},
							{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "大健康研究报告",
								url: "reportList",
								reportId: 10001,
							},
							{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "现代服务业研究报告",
								url: "reportList",
								reportId: 10018,
							},
							{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "大消费研究报告",
								url: "reportList",
								reportId: 10029,
							},
							{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "基建与投资研究报告",
								url: "reportList",
								reportId: 10034,
							}, 
						],
					},
				],
				localRouter_zs: [ //产业招商大脑导航栏顺序
					//产业招商
					{
						code: "A",
						switch: false,
						name: "",
						oldtext: "产业招商",
						type: "cyzs",
						url: "/enterpriseList?type=9",
						open: true,
						morebtn: false,
						icontype: "el-icon-menu",
						children: [{
								code: "A-SSGS",
								switch: false,
								name: "",
								oldtext: "上市公司",
								url: "/enterpriseList?type=9"
							},
							{
								code: "A-LTQY",
								switch: false,
								name: "",
								oldtext: "龙头企业",
								url: "/enterpriseList?type=1"
							},
							{
								code: "A-CXQY",
								switch: false,
								name: "",
								oldtext: "创新企业",
								url: "/enterpriseList?type=2"
							},
							{
								code: "A-YZQY",
								switch: false,
								name: "",
								oldtext: "优质企业",
								url: "/enterpriseList?type=3"
							},
							{
								code: "A-TZJG",
								switch: false,
								name: "",
								oldtext: "投资机构",
								url: "/investment-institutions"
							},
							{
								code: "A-QBNZQY",
								switch: false,
								name: "",
								oldtext: "全部内资企业",
								url: "/totalEnterprises"
							},
							{
								code: "A-WZQY",
								switch: false,
								name: "",
								oldtext: "外资企业",
								url: "/forcapEnterprise"
							},
							{
								code: "A-JWSSQY",
								switch: false,
								name: "",
								oldtext: "境外上市企业",
								url: "/foreignEnterprises"
							},
							{
								code: "A-XZXM",
								switch: true,
								name: "",
								oldtext: "选址项目",
								url: "/siteProject",
								newType: "VIP"
							},
							{
								code: "A-KYJG",
								switch: false,
								name: "",
								oldtext: "科研机构",
								url: "/innovative-resources"
							},
							{
								code: "A-ZSDT",
								switch: false,
								name: "",
								oldtext: "招商地图",
								url: "/enterprise-mapsearch"
							},
							{
								code: "A-XHSH",
								switch: false,
								name: "",
								oldtext: "协会商会",
								url: "/associationList"
							},
							{
								code: "A-ZYZ",
								switch: false,
								name: "",
								oldtext: "专业镇",
								url: "/professionalTown",
							},
						]
					},
					//产业研究
					{
						code: "B",
						switch: false,
						name: "",
						oldtext: "产业研究",
						url: "/industrial-opportunities",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-order",
						children: [{
								code: "B-QGTP",
								switch: false,
								name: "",
								oldtext: "全国图谱",
								url: "/industrial-opportunities"
							},
							{
								code: "B-DDTP",
								switch: false,
								name: "",
								oldtext: "当地图谱",
								url: "/localChainList",
							},
							// {code:"B-CSDSJ",switch:true,name:"城市大数据",oldtext:"城市大数据",url:"/urbanBigDataList"},
							// {code:"B-BSDSJ",switch:true,name:"本市大数据",oldtext:"本市大数据",url:"/urbanBigData?id=locality"},
							{
								code: "B-YJBGK",
								switch: false,
								name: "",
								oldtext: "研究报告库",
								url: "report",
								newType: "VIP"
							},
							{
								code: "B-CYYQK",
								switch: false,
								name: "",
								oldtext: "产业园区库",
								url: "/industrialpark"
							},
							{
								code: "B-TZXMK",
								switch: false,
								name: "",
								oldtext: "投资项目库",
								url: "invest"
							},
							{
								code: "B-NDXMK",
								switch: false,
								name: "",
								oldtext: "拿地项目库",
								url: "land"
							},
							{
								code: "B-DTJC",
								switch: false,
								name: "",
								oldtext: "动态监测",
								url: "/investdynamic"
							},
							{
								code: "B-CYZC",
								switch: false,
								name: "",
								oldtext: "产业政策",
								url: "/policylibrary" //policyLibrary-N policylibrary 2024.4.17暂时隐藏用新的产业政策代替
							},
							{
								code: "B-CYSJK",
								switch: true,
								name: "产业数据库",
								oldtext: "产业数据库",
								url: "/industryLibrary",
								newType:"NEW"
							},
							{
								code: "B-WSTZFX",
								switch: true,
								name: "",
								oldtext: " 外商投资分析",
								url: "/foreignInvestment",
								newType: "NEW",
							},
							{
								code: "T-QYTZBG",
								switch: true,
								name: "",
								oldtext: "企业投资动态报告",
								url: "freeReport",
								reportId: 10006, 
							},
							{code:"T-CXQYRZ",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055},
						]
					},
					//智能推荐
					{
						code: "C",
						switch: false,
						name: "",
						oldtext: "智能推荐",
						url: "/recommendation",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-opportunity",
						children: [{
								code: "C-CYLZSXS",
								switch: false,
								name: "",
								oldtext: "产业链招商",
								url: "/recommendation"
							},
							{
								code: "C-YSZSXS",
								switch: false,
								name: "",
								oldtext: "以商招商线索",
								url: "/investment-clues2"
							},
							// {code:"C-ZDQYZSXS",switch:false,name:"",oldtext:"重点区域招商线索",url:"/investment-clues1"},
							{
								code: "C-ZBZSXS",
								switch: false,
								name: "",
								oldtext: "资本招商线索",
								url: "/investment-clues3"
							},
							{
								code: "C-QYTZCK",
								switch: false,
								name: "",
								oldtext: "企业投资窗口",
								url: "/enterpriseInvestmentWindow",
							},  
							{
								code: "C-CYTZCK",
								switch: false,
								name: "",
								oldtext: "产业投资窗口",
								url: "/industryInvestmentWindow",
							}, 
							{
								code: "C-GLQYXS",
								switch: true,
								name: "",
								oldtext: "关联企业线索",
								url: "/associated-enterprise-clues",
							}, 
							{
								code: "C-GDXSTJ",
								switch: false,
								name: "",
								oldtext: "更多线索推荐",
								url: "/investment-clues1"
							},
						]
					},
					//关系计算器
					{
						code: "E",
						switch: false,
						name: "",
						oldtext: "关系计算器",
						url: "/enterprisesCityRelation",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-platform",
						children: [{
								code: "E-QY－CSGXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-城市 关系计算器",
								url: "/enterprisesCityRelation",
								newType: "HOT",
							},
							{
								code: "E-GXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-企业 关系计算器",
								url: "/relationalcalculator"
							},
							{
								code: "E-ZZDT",
								switch: false,
								name: "",
								oldtext: "作战地图",
								url: "/targetMap",
							},
							{
								code: "E-WDGXW",
								switch: false,
								name: "",
								oldtext: "我的关系网",
								url: "/userrelational"
							},
						]
					},
					{
						code: "J",
						switch: false,
						name: "",
						oldtext: "本地投资趋势",
						url: "/localInvestAnalysis?type=1",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-order",
						children: [{
								code: "J-BSXZTZFX",
								switch: true,
								name: "",
								oldtext: "本省新增投资分析",
								url: "/localInvestAnalysis?type=1",
								// newType: "New",
							},
							{
								code: "J-BS-XZTZFX",
								switch: true,
								name: "",
								oldtext: "本市新增投资分析",
								url: "/localInvestAnalysis?type=2",
								// newType: "New",
							},
						]
					},
					//工作台
					{
						code: "E",
						switch: false,
						name: "",
						oldtext: "工作台",
						url: "/workbench",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-cooperation",
						children: [{
								code: "E-MBQY",
								switch: false,
								name: "",
								oldtext: "目标企业",
								url: "/focusenterprises"
							}, 
							{
									code: "E-DBQY",
									switch: true,
									name: "",
									oldtext: "企业对比",
									url: "/enterprise-compare",
									newType:'NEW',
								},
							{
								code: "E-TJFX",
								switch: false,
								name: "",
								oldtext: "统计分析",
								url: "/statisticalAnalysis"
							},
							{
								code: "E-XMGL",
								switch: false,
								name: "",
								oldtext: "项目管理",
								url: "/projectmanagement"
							},
							{
								code: "E-GJJL",
								switch: false,
								name: "",
								oldtext: "跟进记录",
								url: "/followuprecord"
							},
							{
								code: "E-DBJL",
								switch: false,
								name: "",
								oldtext: "待办记录",
								url: "/todolist"
							},
						]
					},
					// {code:"E-XTGL",switch:false,name:"",oldtext:"系统管理",url:"/systemManagement"}, 在前端默认隐藏系统管理  具体原因不记得了
					//城市监测
					{
						code: "D",
						switch: false,
						name: "",
						oldtext: "城市监测",
						url: "/hongguanshuju-saas",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: 'el-icon-view',
						children: [{
								code: "D-ZHFZ",
								switch: false,
								name: "",
								oldtext: "综合发展",
								url: "/hongguanshuju-saas"
							},
							{
								code: "D-ZSHJ",
								switch: false,
								name: "",
								oldtext: "招商环境",
								url: "/zhaoshanghuanjing2-saas"
							},
							{
								code: "D-CYFZ",
								switch: false,
								name: "",
								oldtext: "产业发展",
								url: "/chanyeyongdi-saas"
							},
						]
					},
					//个人中心
					{
						code: "F",
						switch: false,
						name: "",
						oldtext: "个人中心",
						url: "/baseInformation",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-custom",
						children: [{
								code: "F-GZLY",
								switch: false,
								name: "",
								oldtext: "关注领域",
								url: "/userFocus"
							},
							{
								code: "F-JBZL",
								switch: false,
								name: "",
								oldtext: "基本资料",
								url: "/baseInformation"
							},
							{
								code: "F-MMXG",
								switch: false,
								name: "",
								oldtext: "密码修改",
								url: "/editPassword"
							},
							{
								code: "F-FWSC",
								switch: false,
								name: "",
								oldtext: "服务手册",
								url: "/servicebook"
							},
							{
								code: "F-TCZH",
								switch: false,
								name: "",
								oldtext: "退出账号",
								url: "loginout"
							},
						]
					},
				],
				localRouter_zl: [ //产业治理大脑导航栏顺序
					//产业研究
					{
						code: "B",
						switch: false,
						name: "",
						oldtext: "产业研究",
						url: "/industrial-opportunities",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-order",
						children: [{
								code: "B-QGTP",
								switch: false,
								name: "",
								oldtext: "全国图谱",
								url: "/industrial-opportunities"
							},
							{
								code: "B-DDTP",
								switch: false,
								name: "",
								oldtext: "当地图谱",
								url: "/localChainList"
							},
							{
								code: "B-YJBGK",
								switch: false,
								name: "",
								oldtext: "研究报告库",
								url: "report",
								newType: "VIP"
							},
							{
								code: "B-CYYQK",
								switch: false,
								name: "",
								oldtext: "产业园区库",
								url: "/industrialpark"
							},
							{
								code: "B-TZXMK",
								switch: false,
								name: "",
								oldtext: "投资项目库",
								url: "invest"
							},
							{
								code: "B-NDXMK",
								switch: false,
								name: "",
								oldtext: "拿地项目库",
								url: "land"
							},
							{
								code: "B-DTJC",
								switch: false,
								name: "",
								oldtext: "动态监测",
								url: "/investdynamic"
							},
							{
								code: "B-CYZC",
								switch: false,
								name: "",
								oldtext: "产业政策",
								url: "/policylibrary"
							},
							{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "企业投资动态报告",
								url: "freeReport",
								reportId: 10006, 
							},
							{code:"T-CXQYRZ",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055 },
						]
					},
					//产业招商
					{
						code: "A",
						switch: false,
						name: "",
						oldtext: "产业招商",
						type: "cyzs",
						url: "/enterpriseList?type=9",
						open: true,
						morebtn: false,
						icontype: "el-icon-menu",
						children: [{
								code: "A-SSGS",
								switch: false,
								name: "",
								oldtext: "上市公司",
								url: "/enterpriseList?type=9"
							},
							{
								code: "A-LTQY",
								switch: false,
								name: "",
								oldtext: "龙头企业",
								url: "/enterpriseList?type=1"
							},
							{
								code: "A-CXQY",
								switch: false,
								name: "",
								oldtext: "创新企业",
								url: "/enterpriseList?type=2"
							},
							{
								code: "A-YZQY",
								switch: false,
								name: "",
								oldtext: "优质企业",
								url: "/enterpriseList?type=3"
							},
							{
								code: "A-TZJG",
								switch: false,
								name: "",
								oldtext: "投资机构",
								url: "/investment-institutions"
							},
							{
								code: "A-QBNZQY",
								switch: false,
								name: "",
								oldtext: "全部内资企业",
								url: "/totalEnterprises"
							},
							{
								code: "A-WZQY",
								switch: false,
								name: "",
								oldtext: "外资企业",
								url: "/forcapEnterprise"
							},
							{
								code: "A-JWSSQY",
								switch: false,
								name: "",
								oldtext: "境外上市企业",
								url: "/foreignEnterprises"
							},
							{
								code: "A-KYJG",
								switch: false,
								name: "",
								oldtext: "科研机构",
								url: "/innovative-resources"
							},
							{
								code: "A-ZSDT",
								switch: false,
								name: "",
								oldtext: "招商地图",
								url: "/enterprise-mapsearch"
							},
							{
								code: "A-XHSH",
								switch: false,
								name: "",
								oldtext: "协会商会",
								url: "/associationList"
							},
							{
								code: "A-ZYZ",
								switch: false,
								name: "",
								oldtext: "专业镇",
								url: "/professionalTown"
							},
						]
					},
					//智能推荐
					{
						code: "C",
						switch: false,
						name: "",
						oldtext: "智能推荐",
						url: "/recommendation",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-opportunity",
						children: [{
								code: "C-CYLZSXS",
								switch: false,
								name: "",
								oldtext: "产业链招商",
								url: "/recommendation"
							},
							{
								code: "C-YSZSXS",
								switch: false,
								name: "",
								oldtext: "以商招商线索",
								url: "/investment-clues2"
							},
							// {code:"C-ZDQYZSXS",switch:false,name:"",oldtext:"重点区域招商线索",url:"/investment-clues1"},
							{
								code: "C-ZBZSXS",
								switch: false,
								name: "",
								oldtext: "资本招商线索",
								url: "/investment-clues3"
							},
							{
								code: "C-QYTZCK",
								switch: false,
								name: "",
								oldtext: "企业投资窗口",
								url: "/enterpriseInvestmentWindow",
							},  
							{
								code: "C-CYTZCK",
								switch: false,
								name: "",
								oldtext: "产业投资窗口",
								url: "/industryInvestmentWindow",
							},
							{
								code: "C-GDXSTJ",
								switch: false,
								name: "",
								oldtext: "更多线索推荐",
								url: "/investment-clues1"
							},
						]
					},
					//关系计算器
					{
						code: "B",
						switch: false,
						name: "",
						oldtext: "关系计算器",
						url: "/enterprisesCityRelation",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-platform",
						children: [{
								code: "E-QY－CSGXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-城市 关系计算器",
								url: "/enterprisesCityRelation",
								newType: "HOT",
							},
							{
								code: "E-GXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-企业 关系计算器",
								url: "/relationalcalculator"
							},
					
							{
								code: "E-ZZDT",
								switch: false,
								name: "",
								oldtext: "作战地图",
								url: "/targetMap",
							},
							{
								code: "E-WDGXW",
								switch: false,
								name: "",
								oldtext: "我的关系网",
								url: "/userrelational"
							},
						]
					},
					//关系计算器
					{
						code: "E",
						switch: false,
						name: "",
						oldtext: "关系计算器",
						url: "/enterprisesCityRelation",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-platform",
						children: [{
								code: "E-QY－CSGXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-城市 关系计算器",
								url: "/enterprisesCityRelation",
								newType: "HOT",
							},
							{
								code: "E-GXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-企业 关系计算器",
								url: "/relationalcalculator"
							},

							{
								code: "E-ZZDT",
								switch: false,
								name: "",
								oldtext: "作战地图",
								url: "/targetMap",
							},
							{
								code: "E-WDGXW",
								switch: false,
								name: "",
								oldtext: "我的关系网",
								url: "/userrelational"
							},
						]
					},
					//工作台
					{
						code: "E",
						switch: false,
						name: "",
						oldtext: "工作台",
						url: "/workbench",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-cooperation",
						children: [{
								code: "E-MBQY",
								switch: false,
								name: "",
								oldtext: "目标企业",
								url: "/focusenterprises"
							},
							{
									code: "E-DBQY",
									switch: true,
									name: "",
									oldtext: "企业对比",
									url: "/enterprise-compare",
									newType:'NEW',
								},
							{
								code: "E-TJFX",
								switch: false,
								name: "",
								oldtext: "统计分析",
								url: "/statisticalAnalysis"
							},
							{
								code: "E-XMGL",
								switch: false,
								name: "",
								oldtext: "项目管理",
								url: "/projectmanagement"
							},
							{
								code: "E-GJJL",
								switch: false,
								name: "",
								oldtext: "跟进记录",
								url: "/followuprecord"
							},
							{
								code: "E-DBJL",
								switch: false,
								name: "",
								oldtext: "待办记录",
								url: "/todolist"
							},
						]
					},
					// {code:"E-XTGL",switch:false,name:"",oldtext:"系统管理",url:"/systemManagement"}, 在前端默认隐藏系统管理  具体原因不记得了
					//城市监测
					{
						code: "D",
						switch: false,
						name: "",
						oldtext: "城市监测",
						url: "/hongguanshuju-saas",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: 'el-icon-view',
						children: [{
								code: "D-ZHFZ",
								switch: false,
								name: "",
								oldtext: "综合发展",
								url: "/hongguanshuju-saas"
							},
							{
								code: "D-ZSHJ",
								switch: false,
								name: "",
								oldtext: "招商环境",
								url: "/zhaoshanghuanjing2-saas"
							},
							{
								code: "D-CYFZ",
								switch: false,
								name: "",
								oldtext: "产业发展",
								url: "/chanyeyongdi-saas"
							},
						]
					},
					//个人中心
					{
						code: "F",
						switch: false,
						name: "",
						oldtext: "个人中心",
						url: "/baseInformation",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-custom",
						children: [{
								code: "F-GZLY",
								switch: false,
								name: "",
								oldtext: "关注领域",
								url: "/userFocus"
							},
							{
								code: "F-JBZL",
								switch: false,
								name: "",
								oldtext: "基本资料",
								url: "/baseInformation"
							},
							{
								code: "F-MMXG",
								switch: false,
								name: "",
								oldtext: "密码修改",
								url: "/editPassword"
							},
							// {code:"F-FWSC",switch:false,name:"",oldtext:"服务手册",url:"/servicebook"},
							{
								code: "F-TCZH",
								switch: false,
								name: "",
								oldtext: "退出账号",
								url: "loginout"
							},
						]
					},
				],
				localRouter_xd: [ //产业信贷大脑导航栏顺序
					//域内招商 园区招商全部楼宇 全部企业 为新增页面 默认为true
					{
						code: "A",
						switch: true,
						name: "本地企业",
						oldtext: "本地企业",
						type: "ynzs",
						url: "/allBuildings",
						open: true,
						icontype: "el-icon-menu",
						children: [{
								code: "A-QBLY",
								switch: true,
								name: "",
								oldtext: "全部楼宇",
								url: "/allBuildings"
							},
							{
								code: "A-QBQY",
								switch: true,
								name: "",
								oldtext: "全部企业",
								url: "/allEnterprises"
							},
							{
								code: "A-ZSDT",
								switch: false,
								name: "",
								oldtext: "数字地图",
								url: "/enterprise-mapsearch"
							},
						]
					},
					//产业招商
					{
						code: "A",
						switch: false,
						name: "",
						oldtext: "全国精选企业",
						type: "cyzs",
						url: "/enterpriseList?type=9",
						open: true,
						morebtn: false,
						icontype: "el-icon-menu",
						children: [{
								code: "A-SSGS",
								switch: false,
								name: "",
								oldtext: "上市公司",
								url: "/enterpriseList?type=9"
							},
							{
								code: "A-LTQY",
								switch: false,
								name: "",
								oldtext: "龙头企业",
								url: "/enterpriseList?type=1"
							},
							{
								code: "A-CXQY",
								switch: false,
								name: "",
								oldtext: "创新企业",
								url: "/enterpriseList?type=2"
							},
							{
								code: "A-YZQY",
								switch: false,
								name: "",
								oldtext: "优质企业",
								url: "/enterpriseList?type=3"
							},
							{
								code: "A-TZJG",
								switch: false,
								name: "",
								oldtext: "投资机构",
								url: "/investment-institutions"
							},
							{
								code: "A-QBNZQY",
								switch: false,
								name: "",
								oldtext: "全部内资企业",
								url: "/totalEnterprises"
							},
							{
								code: "A-WZQY",
								switch: false,
								name: "",
								oldtext: "外资企业",
								url: "/forcapEnterprise"
							},
							{
								code: "A-JWSSQY",
								switch: false,
								name: "",
								oldtext: "境外上市企业",
								url: "/foreignEnterprises"
							},
						]
					},
					//产业研究
					{
						code: "B",
						switch: false,
						name: "",
						oldtext: "产业研究",
						url: "/industrial-opportunities",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-order",
						children: [{
								code: "B-QGTP",
								switch: false,
								name: "",
								oldtext: "全国图谱",
								url: "/industrial-opportunities"
							},
							{
								code: "B-DDTP",
								switch: false,
								name: "",
								oldtext: "本市图谱",
								url: "/localChainList",
							},
							{
								code: "B-TZXMK",
								switch: false,
								name: "",
								oldtext: "投资项目库",
								url: "invest"
							},
							{
								code: "B-NDXMK",
								switch: false,
								name: "",
								oldtext: "拿地项目库",
								url: "land"
							},
							{
								code: "B-YJBGK",
								switch: false,
								name: "",
								oldtext: "研究报告库",
								url: "report",
								newType: "VIP"
							},
							{
								code: "B-DTJC",
								switch: false,
								name: "",
								oldtext: "动态监测",
								url: "/investdynamic"
							},
							{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "企业投资动态报告",
								url: "freeReport",
								reportId: 10006, 
							},
							{code:"T-CXQYRZ",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055},
						]
					},
					//智能推荐 以商招商线索——产业链金融  资本招商线索——投贷联动融资线索  企业投资窗口——企业投资（融资）窗口期  产业投资窗口——产业投资（融资）窗口期  热点产业重点企业线索——风口产业的重点企业
					// 优质上市公司招商线索——优质上市公司筛选器  排行榜线索——企业投资排行榜 
					{
						code: "C",
						switch: false,
						name: "",
						oldtext: "智能推荐",
						url: "/investment-clues2",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-opportunity",
						children: [
							// {code:"C-CYLZSXS",switch:false,name:"",oldtext:"产业链招商",url:"/recommendation"},
							{
								code: "C-YSZSXS",
								switch: false,
								name: "",
								oldtext: "产业链金融",
								url: "/investment-clues2"
							},
							{
								code: "C-ZBZSXS",
								switch: false,
								name: "",
								oldtext: "投贷联动融资线索",
								url: "/investment-clues3"
							},
							{
								code: "C-QYTZCK",
								switch: false,
								name: "",
								oldtext: "企业投资（融资）窗口期",
								url: "/enterpriseInvestmentWindow",
							},  
							{
								code: "C-CYTZCK",
								switch: false,
								name: "",
								oldtext: "产业投资（融资）窗口期",
								url: "/industryInvestmentWindow",
							},
							{
								code: "C-GDXSTJ",
								switch: false,
								name: "",
								oldtext: "更多线索推荐",
								url: "/investment-clues1"
							},
						]
					},
					//关系计算器
					{
						code: "E",
						switch: false,
						name: "",
						oldtext: "关系计算器",
						url: "/enterprisesCityRelation",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-platform",
						children: [{
								code: "E-QY－CSGXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-城市 关系计算器",
								url: "/enterprisesCityRelation",
								newType: "HOT",
							},
							{
								code: "E-GXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-企业 关系计算器",
								url: "/relationalcalculator"
							},


							{
								code: "E-WDGXW",
								switch: false,
								name: "",
								oldtext: "我的关系网",
								url: "/userrelational"
							},
						]
					},
					//工作台
					{
						code: "E",
						switch: false,
						name: "",
						oldtext: "工作台",
						url: "/workbench",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-cooperation",
						children: [{
								code: "E-MBQY",
								switch: false,
								name: "",
								oldtext: "目标企业",
								url: "/focusenterprises"
							},
							{
									code: "E-DBQY",
									switch: true,
									name: "",
									oldtext: "企业对比",
									url: "/enterprise-compare",
									newType:'NEW',
								},
							{
								code: "E-ZZDT",
								switch: false,
								name: "",
								oldtext: "作战地图",
								url: "/targetMap",
							},
						]
					},
					//个人中心
					{
						code: "F",
						switch: false,
						name: "",
						oldtext: "个人中心",
						url: "/baseInformation",
						open: true,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-custom",
						children: [{
								code: "F-JBZL",
								switch: true,
								name: "",
								oldtext: "基本资料",
								url: "/baseInformation"
							},
							{
								code: "F-MMXG",
								switch: true,
								name: "",
								oldtext: "密码修改",
								url: "/editPassword"
							},
							{
								code: "F-TCZH",
								switch: true,
								name: "",
								oldtext: "退出账号",
								url: "loginout"
							},
						]
					},
				],
				localRouter_yq: [
					//域内招商 园区招商全部楼宇 全部企业 为新增页面 默认为true
					{
						code: "A1",
						switch: true,
						name: "域内招商",
						oldtext: "域内招商",
						type: "ynzs",
						url: "/allBuildings",
						open: true,
						icontype: "el-icon-menu",
						children: [{
								code: "A-QBLY",
								switch: true,
								name: "",
								oldtext: "全部楼宇",
								url: "/allBuildings"
							},
							{
								code: "A-QBQY",
								switch: true,
								name: "",
								oldtext: "全部企业",
								url: "/allEnterprises"
							},
							// {code:"B-CYYQK",switch:false,name:"",oldtext:"全部园区",url:"/industrialpark"},
							// {code:"A-ABLY",switch:false,name:"",oldtext:"全部园区",url:"/allParks"},、、园区没有列表没有数据
							{
								code: "A-ZSDT",
								switch: false,
								name: "",
								oldtext: "招商地图",
								url: "/enterprise-mapsearch"
							},
						]
					},
					//域外招商
					{
						code: "A",
						switch: false,
						name: "域外招商",
						oldtext: "域外招商",
						type: "cyzs",
						url: "/enterpriseList?type=9",
						open: true,
						icontype: "el-icon-menu",
						children: [{
								code: "A-SSGS",
								switch: false,
								name: "",
								oldtext: "上市公司",
								url: "/enterpriseList?type=9"
							},
							{
								code: "A-LTQY",
								switch: false,
								name: "",
								oldtext: "龙头企业",
								url: "/enterpriseList?type=1"
							},
							{
								code: "A-CXQY",
								switch: false,
								name: "",
								oldtext: "创新企业",
								url: "/enterpriseList?type=2"
							},
							{
								code: "A-YZQY",
								switch: false,
								name: "",
								oldtext: "优质企业",
								url: "/enterpriseList?type=3"
							},
							{
								code: "A-WZQY",
								switch: false,
								name: "",
								oldtext: "外资企业",
								url: "/forcapEnterprise"
							},
							{
								code: "A-QBNZQY",
								switch: false,
								name: "",
								oldtext: "全部内资企业",
								url: "/totalEnterprises"
							},
							{
								code: "A-TZJG",
								switch: false,
								name: "",
								oldtext: "投资机构",
								url: "/investment-institutions"
							},
							{
								code: "A-KYJG",
								switch: false,
								name: "",
								oldtext: "科研机构",
								url: "/innovative-resources"
							},
						],
					},
					//产业研究
					{
						code: "B",
						switch: false,
						name: "产业研究",
						oldtext: "产业研究",
						url: "/industrial-opportunities",
						open: true,
						icontype: "el-icon-s-order",
						children: [{
								code: "B-QGTP",
								switch: false,
								name: "",
								oldtext: "全国图谱",
								url: "/industrial-opportunities"
							},
							{
								code: "B-DDTP",
								switch: false,
								name: "",
								oldtext: "当地图谱",
								url: "/localChainList"
							},
							{
								code: "B-TZXMK",
								switch: false,
								name: "",
								oldtext: "投资项目库",
								url: "invest"
							},
							{
								code: "B-NDXMK",
								switch: false,
								name: "",
								oldtext: "拿地项目库",
								url: "land"
							},
							{
								code: "B-DTJC",
								switch: false,
								name: "",
								oldtext: "动态监测",
								url: "/investdynamic"
							},
							{
								code: "B-CYZC",
								switch: false,
								name: "",
								oldtext: "产业政策",
								url: "/policylibrary"
							},
							{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "企业投资动态报告",
								url: "freeReport",
								reportId: 10006, 
							},
							{code:"T-CXQYRZ",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055},
						]
					},
					//关系计算器
					{
						code: "E",
						switch: false,
						name: "",
						oldtext: "关系计算器",
						url: "/enterprisesCityRelation",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-platform",
						children: [{
								code: "E-QY－CSGXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-城市 关系计算器",
								url: "/enterprisesCityRelation",
								newType: "HOT",
							},
							{
								code: "E-GXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-企业 关系计算器",
								url: "/relationalcalculator"
							},

							{
								code: "E-ZZDT",
								switch: false,
								name: "",
								oldtext: "作战地图",
								url: "/targetMap",
							},
							{
								code: "E-WDGXW",
								switch: false,
								name: "",
								oldtext: "我的关系网",
								url: "/userrelational"
							},
						]
					},
					// //智能推荐 园区招商智能推荐为新增页面 默认为true
					// {code:"D",switch:false,name:"智能推荐",oldtext:"智能推荐",url:"/industrial-opportunities",open:true,icontype:"el-icon-s-opportunity",children:[
					// {code:"B-QGTP",switch:true,name:"",oldtext:"楼宇招商线索",url:"/industrial-opportunities"},
					// {code:"B-DDTP",switch:true,name:"",oldtext:"企业招商线索",url:"/localChainList"},]},
					// //园区大数据
					// {code:"D",switch:false,name:"园区大数据",oldtext:"园区大数据",url:"/industrial-opportunities",open:true,icontype:"el-icon-s-opportunity",children:[
					// {code:"B-QGTP",switch:false,name:"",oldtext:"待定",url:"/industrial-opportunities"}, ]},
					//工作台
					{
						code: "E",
						switch: false,
						name: "工作台",
						oldtext: "工作台",
						url: "/workbench",
						open: true,
						icontype: "el-icon-s-cooperation",
						children: [{
								code: "E-MBQY",
								switch: false,
								name: "",
								oldtext: "目标企业",
								url: "/focusenterprises"
							}, //parkFocusEnterprises
							{
									code: "E-DBQY",
									switch: true,
									name: "",
									oldtext: "企业对比",
									url: "/enterprise-compare",
									newType:'NEW',
								},
							{
								code: "E-TJFX",
								switch: false,
								name: "",
								oldtext: "统计分析",
								url: "/statisticalAnalysis"
							},
							{
								code: "E-XMGL",
								switch: false,
								name: "",
								oldtext: "项目管理",
								url: "/projectmanagement"
							},
							{
								code: "E-GJJL",
								switch: false,
								name: "",
								oldtext: "跟进记录",
								url: "/followuprecord"
							},
							{
								code: "E-DBJL",
								switch: false,
								name: "",
								oldtext: "待办记录",
								url: "/todolist"
							},
						]
					},
					//个人中心
					{
						code: "F",
						switch: false,
						name: "个人中心",
						oldtext: "个人中心",
						url: "/baseInformation",
						open: true,
						openicon: true,
						icontype: "el-icon-s-custom",
						children: [{
								code: "F-JBZL",
								switch: false,
								name: "",
								oldtext: "基本资料",
								url: "/baseInformation"
							},
							{
								code: "F-MMXG",
								switch: false,
								name: "",
								oldtext: "密码修改",
								url: "/editPassword"
							},
							// {code:"F-FWSC",switch:false,name:"",oldtext:"服务手册",url:"/servicebook"},
							{
								code: "F-TCZH",
								switch: false,
								name: "",
								oldtext: "退出账号",
								url: "loginout"
							},
						]
					},
				],
				//战略投资大脑 导航栏顺序
				localRouter_tz: [
					// 投资动态
					{
						code: "T",
						switch: true,
						name: "产业投资动态",
						oldtext: "产业投资动态",
						type: "tzdt",
						url: "/investment-clues3",
						open: true,
						icontype: "el-icon-view",
						children: [{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "创新企业融资",
								url: "/investment-clues3"
							},
							{
								code: "T-BGQYND",
								switch: true,
								name: "",
								oldtext: "上市公司投资",
								url: "/markenterprise"
							},
							{
								code: "T-LTQYND",
								switch: true,
								name: "",
								oldtext: "企业拿地投资",
								url: "/landenterprise"
							},
							{
								code: "T-HYTZDT",
								switch: true,
								name: "",
								oldtext: "产业资讯动态",
								url: "/industryInvestment"
							},
							{
								code: "B-CYZC",
								switch: true,
								name: "",
								oldtext: "产业政策监测",
								url: "/policylibrary"
							},
						],
					},
					{
						code: "R",
						switch: true,
						name: "研究报告库",
						oldtext: "研究报告库",
						type: "yjbg",
						url: "report",
						open: true,
						icontype: "el-icon-s-management",
						children: [{
								code: "R-SZJJ",
								switch: true,
								name: "",
								oldtext: "数字经济",
								url: "reportList",
								reportId: 10005,
							},
							{
								code: "R-GDZZ",
								switch: true,
								name: "",
								oldtext: "高端制造",
								url: "reportList",
								reportId: 10014,
							},
							{
								code: "R-NYHBCL",
								switch: true,
								name: "",
								oldtext: "能源环保材料",
								url: "reportList",
								reportId: 10024,
							},
							{
								code: "R-DJK",
								switch: true,
								name: "",
								oldtext: "大健康",
								url: "reportList",
								reportId: 10001,
							},
							{
								code: "R-XDFWY",
								switch: true,
								name: "",
								oldtext: "现代服务业",
								url: "reportList",
								reportId: 10018,
							},
							{
								code: "R-DXF",
								switch: true,
								name: "",
								oldtext: "大消费",
								url: "reportList",
								reportId: 10029,
							},
							{
								code: "R-JJYTZ",
								switch: true,
								name: "",
								oldtext: "基建与投资",
								url: "reportList",
								reportId: 10034,
							},
							{
								code: "R-BGQK",
								switch: true,
								name: "",
								oldtext: "报告全库",
								url: "report",
								newType: "VIP"
							},
							{
								code: "R-QYTZDTBG",
								switch: true,
								name: "",
								oldtext: "企业投资动态报告",
								url: "freeReport",
								reportId: 10006, 
							},
							{code:"R-TZDTYB",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055},
						],
					},
					//产业研究 园区招商智能推荐为新增页面 默认为true
					{
						code: "B",
						switch: true,
						name: "产业研究工具",
						oldtext: "产业研究工具",
						url: "/localChainList",
						open: true,
						icontype: "el-icon-tickets",
						children: [{
								code: "B-DDTP",
								switch: false,
								switch: true,
								name: "",
								oldtext: "本地产业图谱",
								url: "/localChainList"
							},
							{
								code: "B-QGTP",
								switch: true,
								name: "",
								oldtext: "全国产业图谱",
								url: "/industrial-opportunities"
							},
							{
								code: "B-TZXMK",
								switch: true,
								name: "",
								oldtext: "上市公司投资项目库",
								url: "invest"
							},
							{
								code: "B-NDXMK",
								switch: true,
								name: "",
								oldtext: "企业拿地投资项目库",
								url: "land"
							},

						]
					},
					//投资大脑 企业对标研究 为新增页面 默认为true
					{
						code: "DB",
						switch: true,
						name: "企业对标研究",
						oldtext: "企业对标研究",
						type: "qydbyj",
						url: "/markingEnterpriseist?type=9",
						open: true,
						icontype: "el-icon-menu",
						children: [{
								code: "DB-SSGS",
								switch: true,
								name: "",
								oldtext: "上市公司",
								url: "/markingEnterpriseist?type=9"
							},
							{
								code: "DB-LTQY",
								switch: true,
								name: "",
								oldtext: "龙头企业",
								url: "/markingEnterpriseist?type=1"
							},
							{
								code: "DB-NZQY",
								switch: true,
								name: "",
								oldtext: "全部内资企业",
								url: "/markingEnterpriseist?type=0"
							},
							{
								code: "A-WZQY",
								switch: true,
								name: "",
								oldtext: "外资企业",
								url: "/forcapEnterprise"
							},
							{
								code: "A-JWSSQY",
								switch: true,
								name: "",
								oldtext: "境外上市企业",
								url: "/foreignEnterprises"
							},
							{
								code: "A-ZSDT",
								switch: true,
								name: "",
								oldtext: "数字地图",
								url: "/enterprise-mapsearch"
							},
						]
					},
					//投资大脑 投资标的库 为新增页面 默认为true
					{
						code: "A",
						switch: true,
						name: "投资标的库",
						oldtext: "投资标的库",
						type: "tzbd",
						url: "/enterpriseList?type=2&t=1",
						open: true,
						icontype: "el-icon-menu",
						children: [{
								code: "A-CXQY",
								switch: true,
								name: "",
								oldtext: "创新企业库",
								url: "/enterpriseList?type=2&t=2"
							},
							{
								code: "A-YZQY",
								switch: true,
								name: "",
								oldtext: "优质企业库",
								url: "/enterpriseList?type=3&t=2"
							},
							// {code:"A-QBNZQY",switch:true,name:"",oldtext:"全部内资企业库",url:"/totalEnterprises"},
							// {code:"A-WZQY",switch:true,name:"",oldtext:"外资企业库",url:"/forcapEnterprise"},
							// {code:"A-JWSSQY",switch:true,name:"",oldtext:"境外上市企业库",url:"/foreignEnterprises"},	
						]
					},
					// 智能推荐
					{
						code: "C",
						switch: true,
						name: "智能推荐",
						oldtext: "智能推荐",
						url: "/recommendation",
						open: true,
						morebtn: false,
						icontype: "el-icon-s-opportunity",
						children: [{
								code: "C-CYLZSXS",
								switch: true,
								name: "",
								oldtext: "产业投资推荐",
								url: "/recommendation"
							},
							// {code:"C-YZQYTJ",switch:true,name:"",oldtext:"优质企业推荐",url:"/intelligentRecommendation?type=3"},  
							// {code:"C-ZYJGTJ",switch:true,name:"",oldtext:"专业机构推荐",url:"/intelligentRecommendation?type=6"},
							// {code:"C-KYJGTJ",switch:true,name:"",oldtext:"科研机构推荐",url:"/intelligentRecommendation?type=7"},
							{
								code: "C-ZDQYQYPH",
								switch: true,
								name: "",
								oldtext: "区域企业推荐",
								url: "/investment-clues1"
							},
							{
								code: "C-YQQYTJ",
								switch: true,
								name: "",
								oldtext: "园区企业推荐",
								url: "/industrialpark" 
							},
						]
					},
					//关系计算器 因为两个板块名字相似会导致冲突所以额外命名一个板块code 后台无法控制隐藏展示的 前端写死展示
					{
						code: "E",
						switch: true,
						name: "",
						oldtext: "关系计算器",
						url: "/enterprisesCityRelation",
						openicon: true,
						open: false,
						morebtn: false,
						icontype: "el-icon-s-platform",
						children: [{
								code: "E-QY－CSGXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-城市 关系计算器",
								url: "/enterprisesCityRelation",
								newType: "HOT",
							},
							{
								code: "E-GXJSQ",
								switch: false,   
								name: "",
								oldtext: "企业-企业 关系计算器",
								url: "/relationalcalculator",
							},

							{
								code: "E-ZZDT",
								switch: false,
								name: "",
								oldtext: "投资地图",
								url: "/targetMap",
							},
							{
								code: "E-WDGXW",
								switch: true,
								name: "",
								oldtext: "我的关系网",
								url: "/userrelational"
							},
						]
					},

					//工作台
					{
						code: "E",
						switch: true,
						name: "",
						oldtext: "工作台",
						url: "/workbench",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-cooperation",
						children: [{
								code: "E-MBQY",
								switch: true,
								name: "",
								oldtext: "投资标的",
								url: "/focusenterprises"
							},
							{
									code: "E-DBQY",
									switch: true,
									name: "",
									oldtext: "企业对比",
									url: "/enterprise-compare",
									newType:'NEW',
								},
							{
								code: "E-TJFX",
								switch: true,
								name: "",
								oldtext: "统计分析",
								url: "/statisticalAnalysis"
							},
							{
								code: "E-XMGL",
								switch: true,
								name: "",
								oldtext: "项目管理",
								url: "/projectmanagement"
							},
							{
								code: "E-GJJL",
								switch: true,
								name: "",
								oldtext: "跟进记录",
								url: "/followuprecord"
							},
							{
								code: "E-DBJL",
								switch: true,
								name: "",
								oldtext: "待办记录",
								url: "/todolist"
							},
						]
					},
					// {code:"E-XTGL",switch:false,name:"",oldtext:"系统管理",url:"/systemManagement"}, 在前端默认隐藏系统管理  具体原因不记得了 
					//个人中心
					{
						code: "F",
						switch: true,
						name: "",
						oldtext: "个人中心",
						url: "/baseInformation",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-custom",
						children: [{
								code: "F-GZLY",
								switch: true,
								name: "",
								oldtext: "关注领域",
								url: "/userFocus"
							},
							{
								code: "F-JBZL",
								switch: true,
								name: "",
								oldtext: "基本资料",
								url: "/baseInformation"
							},
							{
								code: "F-MMXG",
								switch: true,
								name: "",
								oldtext: "密码修改",
								url: "/editPassword"
							},
							{
								code: "F-TCZH",
								switch: true,
								name: "",
								oldtext: "退出账号",
								url: "loginout"
							},
						]
					},
				],
				//产业研究大脑 
				localRouter_yj: [ //产业研究大脑导航栏顺序
				{
					code: "J",
					switch: true,
					name: "区域竞争力研究",
					oldtext: "区域竞争力研究",
					type: "qyjzl",
					url: "/regional-competitiveness",
					open: true,
					icontype: "el-icon-s-management",
					children: [{
						code: "J-SSJZL",
						switch: true,
						name: "",
						oldtext: "省市竞争力研究",
						url: "/regional-competitiveness?type=1", 
						// newType:"NEW"
					},{
						code: "J-CSJZL",
						switch: true,
						name: "",
						oldtext: "城市竞争力研究",
						url: "/regional-competitiveness?type=2", 
						// newType:"NEW"
					}, 
					{
						code: "B-WSTZFX",
						switch: true,
						name: "",
						oldtext: "外商投资分析",
						url: "/foreignInvestment",
						newType: "NEW",
					},
					],},
					{
						code: "R",
						switch: true,
						name: "产业研究-行业报告库",
						oldtext: "产业研究",
						type: "yjbg",
						url: "researchIndex", 
						open: true,
						icontype: "el-icon-s-management",
						children: [{
								code: "R-SZJJ",
								switch: true,
								name: "",
								oldtext: "数字经济",
								url: "reportList",
								reportId: 10005,
							},
							{
								code: "R-GDZZ",
								switch: true,
								name: "",
								oldtext: "高端制造",
								url: "reportList",
								reportId: 10014,
							},
							{
								code: "R-NYHBCL",
								switch: true,
								name: "",
								oldtext: "能源环保材料",
								url: "reportList",
								reportId: 10024,
							},
							{
								code: "R-DJK",
								switch: true,
								name: "",
								oldtext: "大健康",
								url: "reportList",
								reportId: 10001,
							},
							{
								code: "R-XDFWY",
								switch: true,
								name: "",
								oldtext: "现代服务业",
								url: "reportList",
								reportId: 10018,
							},
							{
								code: "R-DXF",
								switch: true,
								name: "",
								oldtext: "大消费",
								url: "reportList",
								reportId: 10029,
							},
							{
								code: "R-JJYTZ",
								switch: true,
								name: "",
								oldtext: "基建与投资",
								url: "reportList",
								reportId: 10034,
							},
							{
								code: "R-BGQK",
								switch: true,
								name: "",
								oldtext: "报告全库",
								url: "report",
								newType: "VIP"
							},
							{
								code: "R-QYTZDTBG",
								switch: true,
								name: "",
								oldtext: "企业投资动态报告",
								url: "freeReport",
								reportId: 10006, 
							},
							{code:"R-TZDTYB",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055, },
						],
					},
					{
						code: "L",
						switch: true,
						name: "产业链研究-产业图谱",
						oldtext: "产业链研究",
						type: "cylyj",
						url: "/localChainList",
						open: true,
						icontype: "el-icon-s-management",
						children: [{
								code: "L-SZJJ",
								switch: true,
								name: "",
								oldtext: "数字经济",
								url: "/allchain?type=10561"
							},
							{
								code: "L-GDZZ",
								switch: true,
								name: "",
								oldtext: "高端制造",
								url: "/allchain?type=10562"
							},
							{
								code: "L-NYHBCL",
								switch: true,
								name: "",
								oldtext: "能源环保材料",
								url: "/allchain?type=10563"
							},
							{
								code: "L-DJK",
								switch: true,
								name: "",
								oldtext: "大健康",
								url: "/allchain?type=10560"
							},
							{
								code: "L-XDFWY",
								switch: true,
								name: "",
								oldtext: "现代服务业",
								url: "/allchain?type=10637"
							},
							{
								code: "L-DXF",
								switch: true,
								name: "",
								oldtext: "大消费",
								url: "/allchain?type=10644"
							},
							{
								code: "B-DDTP",
								switch: false,
								name: "",
								oldtext: "当地产业链",
								url: "/localChainList",
							},
							{
								code: "B-CYSJK",
								switch: true,
								name: "产业数据库",
								oldtext: "产业数据库",
								url: "/industryLibrary",
								newType:"NEW"
							},
							// {
							// 	code:"B-BSTP",
							// 	switch:true,
							// 	name:"",
							// 	oldtext:"本省产业链",
							// 	url:"/localChainList?type=province",
							// 	},	
						],
					},
					//产业招商
					{
						code: "A",
						switch: false,
						name: "",
						oldtext: "重点企业研究",
						type: "cyzs",
						url: "/enterpriseList?type=9",
						open: true,
						morebtn: false,
						icontype: "el-icon-menu",
						children: [{
								code: "A-SSGS",
								switch: false,
								name: "",
								oldtext: "上市公司",
								url: "/enterpriseList?type=9"
							},
							{
								code: "A-LTQY",
								switch: false,
								name: "",
								oldtext: "龙头企业",
								url: "/enterpriseList?type=1"
							},
							{
								code: "A-CXQY",
								switch: false,
								name: "",
								oldtext: "创新企业",
								url: "/enterpriseList?type=2"
							},
							{
								code: "A-YZQY",
								switch: false,
								name: "",
								oldtext: "优质企业",
								url: "/enterpriseList?type=3"
							},
							{
								code: "A-QBNZQY",
								switch: false,
								name: "",
								oldtext: "全部内资企业",
								url: "/totalEnterprises"
							},
							{
								code: "A-WZQY",
								switch: false,
								name: "",
								oldtext: "外资企业",
								url: "/forcapEnterprise"
							},
							{
								code: "A-JWSSQY",
								switch: false,
								name: "",
								oldtext: "境外上市企业",
								url: "/foreignEnterprises"
							},
							{
								code: "A-ZSDT",
								switch: false,
								name: "",
								oldtext: "数字地图",
								url: "/enterprise-mapsearch"
							},
							{
								code: "A-KYJG",
								switch: false,
								name: "",
								oldtext: "研发机构",
								url: "/innovative-resources"
							},
							
							{
								code: "T-TZJG",
								switch: true,
								name: "",
								oldtext: "投资机构",
								url: "/investment-institutions"
							},
							{
								code: "A-XHSH",
								switch: false,
								name: "",
								oldtext: "协会商会",
								url: "/associationList"
							},
							{
								code: "A-ZYZ",
								switch: false,
								name: "",
								oldtext: "专业镇",
								url: "/professionalTown",
							},
						]
					},
					// 投资动态 从投资大脑搬移
					{
						code: "T",
						switch: true,
						name: "产业动态跟踪",
						oldtext: "产业动态跟踪",
						type: "cydt",
						url: "/investment-clues3",
						open: true,
						icontype: "el-icon-view",
						children: [{
								code: "T-CXQYRZ",
								switch: true,
								name: "",
								oldtext: "创新企业融资",
								url: "/investment-clues3"
							},
							{
								code: "T-BGQYND",
								switch: true,
								name: "",
								oldtext: "上市公司投资",
								url: "/markenterprise"
							},
							{
								code: "T-LTQYND",
								switch: true,
								name: "",
								oldtext: "企业拿地投资",
								url: "/landenterprise"
							},
							{
								code: "T-HYTZDT",
								switch: true,
								name: "",
								oldtext: "产业资讯动态",
								url: "/industryInvestment"
							},
							{
								code: "B-CYZC",
								switch: true,
								name: "",
								oldtext: "产业政策监测",
								url: "/policylibrary"
							},
							{
								code: "C-QYTZCK",
								switch: false,
								name: "",
								oldtext: "企业投资窗口",
								url: "/enterpriseInvestmentWindow",
							},
							{
								code: "C-CYTZCK",
								switch: false,
								name: "",
								oldtext: "产业投资窗口",
								url: "/industryInvestmentWindow",
							}, 
							{
								code: "B-TZXMK",
								switch: false,
								name: "",
								oldtext: "投资项目库",
								url: "invest"
							},
							{
								code: "B-NDXMK",
								switch: false,
								name: "",
								oldtext: "拿地项目库",
								url: "land"
							},
						],
					},
					// 智能推荐 拆分出来的细节页面 
					{
						code: "C",
						switch: true,
						name: "产业排行榜",
						oldtext: "产业排行榜",
						type: "cyphb",
						url: "/investment-clues7",
						openicon: true,
						open: false,
						icontype: "el-icon-view",
						children: [{
								code: "C-ZDCYZDCS",
								switch: true,
								name: "",
								oldtext: "重点产业城市排行",
								url: "/investment-clues7"
							},
							{
								code: "C-RDCYQYPH",
								switch: true,
								name: "",
								oldtext: "热点产业企业排行",
								url: "/investment-clues5"
							},
							{
								code: "C-ZDCSZDCY",
								switch: true,
								name: "",
								oldtext: "重点城市产业排行",
								url: "/investment-clues6"
							},
							{
								code: "C-ZDQYQYPH",
								switch: true,
								name: "",
								oldtext: "重点区域企业排行",
								url: "/investment-clues1"
							},
							{
								code: "C-YZSSGSPH",
								switch: true,
								name: "",
								oldtext: "上市公司排行榜",
								url: "/investment-clues4"
							},
							{
								code: "C-QYTZPH",
								switch: true,
								name: "",
								oldtext: "企业投资排行榜",
								url: "/investment-clues8"
							},
						],
					},
					 
					//关系计算器
					{
						code: "E",
						switch: false,
						name: "",
						oldtext: "关系计算器",
						url: "/enterprisesCityRelation",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-platform",
						children: [{
								code: "E-QY－CSGXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-城市 关系计算器",
								url: "/enterprisesCityRelation",
								newType: "HOT",
							},
							{
								code: "E-GXJSQ",
								switch: false,
								name: "",
								oldtext: "企业-企业 关系计算器",
								url: "/relationalcalculator"
							},
							{
								code: "E-ZZDT",
								switch: false,
								name: "",
								oldtext: "作战地图",
								url: "/targetMap",
							},
							{
								code: "E-WDGXW",
								switch: false,
								name: "",
								oldtext: "我的关系网",
								url: "/userrelational"
							},
						]
					},
					//工作台
					{
						code: "E",
						switch: false,
						name: "",
						oldtext: "工作台",
						url: "/workbench",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-cooperation",
						children: [{
								code: "E-MBQY",
								switch: false,
								name: "",
								oldtext: "目标企业",
								url: "/focusenterprises"
							},
							{
									code: "E-DBQY",
									switch: true,
									name: "",
									oldtext: "企业对比",
									url: "/enterprise-compare",
									newType:'NEW',
								},
							{
								code: "E-TJFX",
								switch: false,
								name: "",
								oldtext: "统计分析",
								url: "/statisticalAnalysis"
							},
							{
								code: "E-XMGL",
								switch: false,
								name: "",
								oldtext: "项目管理",
								url: "/projectmanagement"
							},
							{
								code: "E-GJJL",
								switch: false,
								name: "",
								oldtext: "跟进记录",
								url: "/followuprecord"
							},
							{
								code: "E-DBJL",
								switch: false,
								name: "",
								oldtext: "待办记录",
								url: "/todolist"
							},
						]
					},
					//个人中心
					{
						code: "F",
						switch: false,
						name: "",
						oldtext: "个人中心",
						url: "/baseInformation",
						open: false,
						openicon: true,
						morebtn: false,
						icontype: "el-icon-s-custom",
						children: [
							// {code:"F-GZLY",switch:false,name:"",oldtext:"关注领域",url:"/userFocus"},
							{
								code: "F-JBZL",
								switch: false,
								name: "",
								oldtext: "基本资料",
								url: "/baseInformation"
							},
							{
								code: "F-MMXG",
								switch: false,
								name: "",
								oldtext: "密码修改",
								url: "/editPassword"
							},
							// {code:"F-FWSC",switch:false,name:"",oldtext:"服务手册",url:"/servicebook"},
							{
								code: "F-TCZH",
								switch: false,
								name: "",
								oldtext: "退出账号",
								url: "loginout"
							},
						]
					},
				],
			}
		},
		props: {
			msg: String,
			curindex: {
				required: false,
				default: '',
			},
			openmeun: Boolean,
			smScrennFull: {
				required: false,
				default: false,
			},
			haspagetitle: {
				required: false,
				default: false,
			},
			// 新的参数
		 
			mkopen: {
				required: false,
				default: true,
			},
			mktype:{
				required: false,
				default: '',
			},
			itemcode: String,
			docutitle: {
				required: false,
				default: '',
			},
		},
		components: {
			messgeAlertPop
		},
		watch: {
			itemcode: {
				handler(newValue, oldValue) {
					this.type = newValue;
					this.toogleBlockOpen(); //用于下拉框是否展示

				}
			},
		},
		created() {
			this.getuserinfor();
			this.leftNavTitle = this.userdata.userAbbr.length == '' ? this.userdata.currentCity.text : this.userdata.userAbbr;
			this.logoimg=this.userdata.logo;
			// if(this.curWebsite.type == 6){
			// 	this.leftNavTitle='中投顾问';
			// }
		},
		mounted() { 
			this.turnUserMenu() 
			this.toogleBlockOpen();   
			if((this.curWebsite.type == 1 || this.curWebsite.type == 8 || this.curWebsite.type == 4 || this.curWebsite.type == 6) && this.userdata.groupType == 0 && !this.userdata.autoOperate){	
				console.log('自动操作');
				this.testUserAutoOperationNew();
			} 
			
		},
		methods: {
			...mapMutations({
				set_collapse: "SET_COLLAPSE",
			}),
			//折叠菜单
			onClickfoldBtn() {
				console.log('点击展开收起',this.isCollapse)
				this.set_collapse(!this.isCollapse)
			},
			//判断试用用户登录次数自动弹框 
			//如果当前用户为研究大脑、信贷大脑的试用账户且刚刚登陆 则自动打开使用指引弹框
			// this.userdata.groupType=0;
			//招商大脑试用账户只在第一次登录时展开,易用正式的试用指引或者第一次切换正式版时展开全部试用指引
			testUserAutoOperationNew(){ 
				this.userdata.autoOperate = true;
				var	operatDemoType="total"; 
				if((this.curWebsite.type == 1 || this.curWebsite.type == 8) && this.userdata.loginNum == 1){ 
					this.userdata.autoOperate = false;
					operatDemoType="zsdn_version";
					this.userdata.loginNum=this.userdata.loginNum+1;
				} 
				var datasm1 = JSON.stringify(this.userdata);
				localStorage.setItem('userData', datasm1);
				sessionStorage.setItem('userData', datasm1);  
				console.log(operatDemoType,3)
				this.bus.$emit('operatDemo', true,operatDemoType);

				// this.bus.$emit('operatDemo',true,operatDemoType);
			},
			//招商大脑简易版和专业版切换
			zsdnVersionToggle(type) { 
				if(this.zsdn_version == type){
					return;
				}
				this.zsdn_version = type;
				this.userdata.zsdn_version = type;
				this.userdata.zsdn_version_num=this.userdata.zsdn_version_num+1;
				var datasm1 = JSON.stringify(this.userdata);
				localStorage.setItem('userData', datasm1);
				sessionStorage.setItem('userData', datasm1);
				if(type == 1){
					this.routerself('/invest-project-trend?type=3');
				}else {
					this.routerself('/totalEnterprises');
				} 
			},
			getTitleFontSize(title) { //12.5提出字数太大要改变字体大小后又觉得不需要改变
				let font = 'fontSize:20px';
				// if(title.length<=7){
				// 	font = "fontSize:20px";
				// }else{
				// 	font = "fontSize:"+(18-(title.length-7))*1+'px';
				// } 
				return font;
			},
			showMoreNav(list) { //点击更多功能时将list.morebtn转为false,并将所有的子集元素switch改为true
				list.morebtn = false;
				var listch = list.children;
				for (var d = 0; d < listch.length; d++) {
					list.children[d].switch = true;
				}
				// console.log(list)
			},
			//将不能被显示的链接进行隐藏判断
			navHiddenInfor(list) {
				//先把所有不显示的信息栏剔除 
				for (var i = 0; i < list.length; i++) {
					var listch = list[i].children;
					var listnew = listch.filter(dd => {
						return dd.switch;
					});
					list[i].children = listnew;
				}
				//循环判断该模块是否有个更多按钮 有就需要在这里面进行将switch变更false，morebtn也变为true,
				for (var i = 0; i < list.length; i++) {
					var listch = list[i].children;
					for (var d = 0; d < listch.length; d++) {
						let tabname = listch[d].oldtext; //用oldtext是因为有些文字是由前台写死的 后台还没加上 后期统一更新后即可改为name
						if (this.cyzsMoreshow.indexOf(tabname) > 0) {
							list[i].morebtn = true;
							// list[i].children[d].oldtext=listch[d].oldtext+'d';
							list[i].children[d].switch = false;
						}
					}
				}
				//研究大脑 直辖城市 隐藏本省产业链
				// if(this.curWebsite.type == 6){
				// 	var curcity=this.userdata.currentCity.text;
				// 		let zhixia="&北京市天津市上海市重庆市";
				// 		if(this.userdata.isZhixia){
				// 		webmenu.forEach(list=>{
				// 			if(list.code == 'L'){
				// 				list.children.forEach(item=>{
				// 					if(item.oldtext=='本省产业链'){
				// 						item.switch=false;
				// 					}
				// 				})
				// 			}
				// 		})
				// 	}
				// }
				
				
				this.localRouter = list;
			},
			//当前页面高标亮显示 
			toogleBlockOpen() {
				var title = '';
				for (var i = 0; i < this.localRouter.length; i++) { 
					for (var d = 0; d < this.localRouter[i].children.length; d++) {
							this.localRouter[i].open = this.mkopen;
							this.mkcode=this.localRouter[i].code;
						if (this.localRouter[i].children[d].code == this.itemcode) {
							title = this.localRouter[i].children[d].oldtext;
							if (!this.localRouter[i].children[d].switch) {
								this.localRouter[i].morebtn = false;
								this.localRouter[i].children.forEach(dd => {
									dd.switch = true;
								})
							} 
						}
					}
				}
				title = this.docutitle == "" ? title : this
				.docutitle; //优先拿页面设置的，如果是菜单里有的，页面就不需要设置了 这是为了给那些菜单里没有又想要高标亮显示的页面设置的
				if (this.docutitle != "" || title != "") {
					// console.log('set document title',title + "-")
					document.title = title + "-" + this.curWebsite.name;
				}
			},
			//将后台传过来的menu和本地的menuurl结合
			turnUserMenu() {
				var setmenu = this.userdata.menu;
				var webmenu = [];
				// console.log(this.curWebsite)
				if (this.curWebsite.type == 1 || this.curWebsite.type == 7 || this.curWebsite.type == 8) {
					if(this.zsdn_version == 1){
						webmenu = this.localRouter_zs_simple;
					}else{
						if(this.curWebsite.type  == 8){
								this.localRouter_zs[1].children=this.localRouter_zs[1].children.filter(list=>{
								return list.code != 'T-QYTZBG';
							})
						}
						webmenu = this.localRouter_zs;
					}  
					 
				} else if (this.curWebsite.type == 2) {
					webmenu = this.localRouter_zl;
				} else if (this.curWebsite.type == 4) {
					webmenu = this.localRouter_xd;
				} else if (this.curWebsite.type == 3) {
					webmenu = this.localRouter_yq;
				} else if (this.curWebsite.type == 5) {
					webmenu = this.localRouter_tz;
				} else if (this.curWebsite.type == 6) {
					var lyqylist= {
						code: "A",
						switch: true,
						name: "本地企业研究",
						oldtext: "本地企业研究",
						type: "ynzs",
						url: "/allBuildings",
						open: true,
						icontype: "el-icon-menu",
						children: [{
								code: "A-QBLY",
								switch: true,
								name: "",
								oldtext: "全部楼宇",
								url: "/allBuildings"
							},
							{
								code: "A-QBQY",
								switch: true,
								name: "",
								oldtext: "全部企业",
								url: "/allEnterprises"
							},
							{
								code: "A-LYSZDT",
								switch: true,
								name: "",
								oldtext: "楼宇数字地图",
								url: "/building-mapsearch"
							},
						]
					};
					var cabinetList=[];
					if(this.userdata.city == 4403){
						for(var i=0;i<this.localRouter_yj.length;i++){
							cabinetList.push(this.localRouter_yj[i]);
							if(i == 3){
								cabinetList.push(lyqylist);
							}
						}
					 this.localRouter_yj=cabinetList;
					}
					webmenu = this.localRouter_yj; 
				}
				//第一步 先将后台设置的两级数据变成一级
				let setmenu1 = [];
				for (var i = 0; i < setmenu.length; i++) {
					if (setmenu[i].code != "Z") {
						setmenu1.push({
							name: setmenu[i].name,
							code: setmenu[i].code
						})
						for (var d = 0; d < setmenu[i].children.length; d++) {
							setmenu1.push({
								name: setmenu[i].children[d].name,
								code: setmenu[i].children[d].code
							})
						}
					}
				}
				// 第二步 将后台传来的数据放入前端的菜单列表里比对，设置switch
				for (var i = 0; i < setmenu1.length; i++) {
					let setcode = setmenu1[i].code;
					let setname = setmenu1[i].name;
					for (var d = 0; d < webmenu.length; d++) {
						if (setcode == webmenu[d].code) {
							webmenu[d].name = setname;
							webmenu[d].switch = true;
						}
						for (var t = 0; t < webmenu[d].children.length; t++) {
							if (setcode == webmenu[d].children[t].code) {
								webmenu[d].children[t].name = setname;
								webmenu[d].children[t].switch = true;
							}
						}
					}
				}
				// this.userdata.province=36;
				//本地投资趋势仅限于招商大脑 用户注册地为江西36、安徽34使用
				if(this.userdata.province == 36 || this.userdata.province == 34 || this.userdata.province == 44){ 
					for(var i=0;i<webmenu.length;i++){
						if(webmenu[i].oldtext == '本地投资趋势'){
							webmenu[i].switch=true;
						}
					}  
				}
				//20240422 招商办渠道用户隐藏服务手册
				if(this.curWebsite.type == 8){
					console.log('服务手册',webmenu);
					for(var i=0;i<webmenu.length;i++){
						for(var d=0;d<webmenu[i].children.length;d++){
							if(webmenu[i].children[d].oldtext == '服务手册'){
								webmenu[i].children[d].switch=false;
							}
						}
					}
				}
				if (this.curWebsite.type == 1  || this.curWebsite.type == 6 || this.curWebsite.type == 5) {
					this.navHiddenInfor(webmenu); 
				} else {
					this.localRouter = webmenu;
				}
    
				// console.log('webmenu',webmenu)
			},
			//新的跳转链接
			navClickLink(item) {
				var url = item.url;
				if (url == 'loginout') {
					this.logout()
				} else if (url == 'report') {
					window.open(ajaxapi.getReportUrl() + '&token=' + this.userdata.token); //研究报告库外部跳转
				} else if (url == 'reportList') {
					window.open(ajaxapi.getReportListUrl(item.reportId) + '&token=' + this.userdata.token); //研究报告库外部跳转
				} else if (url == "land" || url == 'invest') {  
					// window.open(ajaxapi.getBigDataUrl(url) + '&token=' + this.userdata.token+areaInfor); // 外部跳转拿地信息库 投资项目库跳转
					this.$axios.get(this.$api.enterpriseapi.land.url() ,{
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {  
						window.open(res.data.data[url]);
						// that.listUrl=res.data.data.invest; 
					})  
				} else if (url == 'freeReport') { //跳转到免费报告库
					window.open(ajaxapi.getFreeReportUrl(item.reportId));
				} else {
					this.nums++;
					if (url.indexOf('enterpriseList') > 0) {
						if (url.indexOf('?') < 0) {
							url = url + '?t=' + this.nums;
						} else {
							url = url + '&t=' + this.nums;
						}
					}
					this.routerself(url);
				}
			},
			screen() {
				if (!screenfull.enabled) { // 如果不允许进入全屏，发出不允许提示
					this.$message({
						message: '不支持全屏',
						type: 'warning'
					})
					return false
				}
				screenfull.toggle(document.getElementById('full-screen'));
				// this.$message({
				//     message: '已开启全屏',
				//     type: 'success'
				//   })
			},
			getuserinfor() {
				
				let dataddd = sessionStorage.getItem('userData') ? sessionStorage.getItem('userData') : localStorage
					.getItem('userData');
				if (typeof(dataddd) == 'object') {
					this.userdata = dataddd;
				} else {
					this.userdata = JSON.parse(dataddd);
				}
				// this.usernotionlistsave=this.taglistfun(this.userdata.notionText,this.userdata.notion); 
				this.islogin = this.userdata.datetime != undefined;
				var nowdate = new Date().getMonth() + 1 + '-' + new Date().getDate();
				var logintime = this.userdata.datetime;
				// 正式环境清除所有console.log
				var logbtn = process.env.NODE_ENV === 'production';
				if (process.env.NODE_ENV === 'production' && !this.userdata.log) {
					if (window) {
						window.console.log = function() {};
					}
				}
				console.log(nowdate, logintime, this.userdata);
				if (logintime != nowdate || !this.islogin) {
					this.logout();
				};
				this.zsdn_version = this.userdata.zsdn_version;
				this.groupType = this.userdata.groupType; //区分正式或者试用账户（版本一樣 只是試用時間不一樣）
				this.edition = this.userdata.edition; //區分普通版和正式版  
			},
		},
	}
</script>

<style>
	@import url("../../css/leftnav.css");
	.logo-img{
		 width: 50px;height: 50px;float: left;
	}
</style>